(function(){
  'use strict';

  var CODE_KEY = 'paccoDiscountCode';
  var htmlEntityMap = {
    '&quot;': '"',
    '&apos;': "'",
    '&lt;': '<',
    '&gt;': '>',
    '&amp;': '&'
  };

  function normalizeJsonString(raw){
    if (!raw) return '';
    var str = String(raw).trim();
    if (!str) return '';
    if (str.indexOf('&') !== -1) {
      str = str.replace(/&(?:quot|apos|lt|gt|amp);/g, function(entity){
        return htmlEntityMap[entity] || entity;
      });
    }
    return str;
  }

  function parseMeta(raw){
    if (!raw) return null;
    if (typeof raw === 'object') return raw;
    var normalized = normalizeJsonString(raw);
    if (!normalized || normalized === 'null' || normalized === 'undefined') return null;
    try{
      return JSON.parse(normalized);
    }catch(_){
      return null;
    }
  }

  function readPct(entry){
    if (entry == null) return 0;
    if (typeof entry === 'number') return entry > 0 ? entry : 0;
    if (typeof entry === 'string') {
      var numeric = Number(entry);
      return Number.isFinite ? (Number.isFinite(numeric) && numeric > 0 ? numeric : 0) : (isFinite(numeric) && numeric > 0 ? numeric : 0);
    }
    if (typeof entry === 'object') {
      var direct = entry.percentage != null ? entry.percentage : (entry.PERCENTAGE != null ? entry.PERCENTAGE : (entry.value != null ? entry.value : entry.VALUE));
      if (direct != null) {
        var numericDirect = Number(direct);
        return Number.isFinite ? (Number.isFinite(numericDirect) && numericDirect > 0 ? numericDirect : 0) : (isFinite(numericDirect) && numericDirect > 0 ? numericDirect : 0);
      }
    }
    return 0;
  }

  function readPctRecursive(entry){
    var direct = readPct(entry);
    if (direct) return direct;
    if (entry && typeof entry === 'object') {
      var fromDefault = readPctRecursive(entry.default || entry.DEFAULT);
      if (fromDefault) return fromDefault;
      var fromValue = readPctRecursive(entry.value || entry.VALUE);
      if (fromValue) return fromValue;
    }
    return 0;
  }

  function getAutomaticPct(meta, variantId){
    if (!meta || typeof meta !== 'object') return 0;
    var automatic = meta.automatic || meta.AUTOMATIC;
    if (!automatic) return 0;

    var variantsMap = automatic.variants || automatic.VARIANTS;
    if (variantsMap && variantId) {
      var keys = [
        String(variantId),
        Number(variantId),
        'gid://shopify/ProductVariant/' + variantId
      ];
      for (var i = 0; i < keys.length; i += 1) {
        var key = keys[i];
        if (key == null) continue;
        if (variantsMap[key] != null) {
          var pctVariant = readPctRecursive(variantsMap[key]);
          if (pctVariant > 0) return pctVariant;
        }
      }
    }

    var pctDefault = readPctRecursive(automatic.default || automatic.DEFAULT);
    if (pctDefault > 0) return pctDefault;

    return readPctRecursive(automatic);
  }

  function getCodesPct(meta, code, variantId){
    if (!meta || typeof meta !== 'object' || !code) return 0;
    var codes = meta.codes || meta.CODES;
    if (!codes) return 0;
    var upperCode = code.toUpperCase();
    var entry = codes[upperCode] || codes[upperCode.toLowerCase()] || codes[upperCode.replace(/[^A-Z0-9_-]/gi, '')];
    if (!entry) return 0;

    var variantsMap = entry.variants || entry.VARIANTS;
    if (variantsMap && variantId) {
      var keys = [
        String(variantId),
        Number(variantId),
        'gid://shopify/ProductVariant/' + variantId
      ];
      for (var i = 0; i < keys.length; i += 1) {
        var key = keys[i];
        if (key == null) continue;
        if (variantsMap[key] != null) {
          var pctVariant = readPctRecursive(variantsMap[key]);
          if (pctVariant > 0) return pctVariant;
        }
      }
    }

    var fallback = readPctRecursive(entry);
    return fallback > 0 ? fallback : 0;
  }

  function detectCode(){
    try{
      var url = new URL(window.location.href);
      var param = (url.searchParams.get('discount') || '').trim();
      if (param) return param.toUpperCase();
      var param2 = (url.searchParams.get('discount_code') || '').trim();
      if (param2) return param2.toUpperCase();
    }catch(_){ }

    var cookieMatch = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/i);
    if (cookieMatch && cookieMatch[1]) {
      try{
        return decodeURIComponent(cookieMatch[1]).trim().toUpperCase();
      }catch(_){
        return cookieMatch[1].trim().toUpperCase();
      }
    }

    try{
      var stored = localStorage.getItem(CODE_KEY);
      if (stored) return stored.trim().toUpperCase();
    }catch(_){ }

    return '';
  }

  function getConfig(){
    var cfg = window.__viCardConfig || {};
    return {
      moneyFormat: cfg.moneyFormat || '${{amount}}',
      minInstallment: Number(cfg.minInstallmentCents) || 0,
      maxInstallments: Number(cfg.maxInstallments) || 1
    };
  }

  var cardMediaCache = window.__viCardMediaCache;
  if(!cardMediaCache || typeof cardMediaCache !== 'object'){
    cardMediaCache = Object.create(null);
    window.__viCardMediaCache = cardMediaCache;
  }

  function isVideoSrc(src){
    return !!(src && /\.(mp4|webm|mov)(\?|$)/i.test(String(src)));
  }

  function normalizeMediaData(data){
    var payload = data && typeof data === 'object' ? data : {};
    var primary = payload.primary || '';
    var secondary = payload.secondary || '';
    var video = payload.video || '';
    if(!video && isVideoSrc(primary)){
      video = primary;
      primary = '';
    }
    return {
      primary: primary,
      secondary: secondary,
      video: video
    };
  }

  function readRootMedia(root){
    if(!root) return normalizeMediaData(null);
    return normalizeMediaData({
      primary: root.getAttribute('data-variant-main') || '',
      secondary: root.getAttribute('data-variant-hover') || '',
      video: root.getAttribute('data-variant-video') || ''
    });
  }

  function fetchVariantMedia(handle, variantId){
    var cleanHandle = handle ? String(handle).trim() : '';
    var cleanVariantId = variantId ? String(variantId).trim() : '';
    if(!cleanHandle || !cleanVariantId){
      return Promise.resolve(normalizeMediaData(null));
    }
    var cacheKey = cleanHandle + ':' + cleanVariantId;
    if(cardMediaCache[cacheKey]){
      return cardMediaCache[cacheKey];
    }
    var url = '/products/' + encodeURIComponent(cleanHandle) + '?view=variant-card-media&variant=' + encodeURIComponent(cleanVariantId);
    cardMediaCache[cacheKey] = fetch(url, {
      credentials: 'same-origin',
      headers: { accept: 'application/json' }
    }).then(function(response){
      if(!response.ok){
        throw new Error('variant-card-media:' + response.status);
      }
      return response.json();
    }).then(function(payload){
      return normalizeMediaData(payload);
    }).catch(function(){
      delete cardMediaCache[cacheKey];
      return normalizeMediaData(null);
    });
    return cardMediaCache[cacheKey];
  }

  var singleVariantGuard = false;
  function ensureSingleVariantGuard(){
    if(singleVariantGuard) return;
    singleVariantGuard = true;
    document.addEventListener('submit', function(ev){
      var form = ev.target && ev.target.closest ? ev.target.closest('.product-item__quick-form[data-vi-one-variant="1"]') : null;
      if (!form) return;
      var datasetVid = form.getAttribute('data-variant-id');
      var hiddenId   = form.querySelector('input[name="id"]');
      var vid = (datasetVid && /^\d+$/.test(datasetVid)) ? datasetVid : (hiddenId ? hiddenId.value : '');
      if (hiddenId && vid && hiddenId.value !== vid) {
        hiddenId.value = vid;
      }
    }, true);
  }

  var carouselJobs = new Set();
  var carouselFrame = 0;
  function scheduleCarouselJob(job){
    carouselJobs.add(job);
    if(carouselFrame) return;
    carouselFrame = requestAnimationFrame(function(){
      carouselFrame = 0;
      var jobs = Array.from(carouselJobs);
      carouselJobs.clear();
      var measurements = jobs.map(function(item){ return item.read(); });
      jobs.forEach(function(item, index){ item.write(measurements[index]); });
    });
  }

  function initCard(target){
    var root = typeof target === 'string' ? document.getElementById(target) : target;
    if(!root || root.dataset.viReady === '1') return;
    root.dataset.viReady = '1';
    ensureSingleVariantGuard();

    var config = getConfig();
    var moneyFormat = config.moneyFormat;
    var minInstall = config.minInstallment;
    var maxInstall = config.maxInstallments;
    var productTitle = root.dataset.productTitle || '';
    var cardUid = root.getAttribute('id') || '';
    var activeVariantRequest = 0;

    function setupCarousel(carousel){
      if (!carousel) return;
      
      var viewport = carousel.querySelector('.vi-viewport');
      var rail = carousel.querySelector('.vi-rail');
      if(!viewport || !rail) return;

      var prev = carousel.querySelector('[data-vi-prev]');
      var next = carousel.querySelector('[data-vi-next]');

      var carouselJob = {
        read: function(){
          var width = viewport.clientWidth;
          var scrollWidth = viewport.scrollWidth;
          var left = viewport.scrollLeft;
          return {overflow: scrollWidth > width + 2, atStart: left <= 0, atEnd: left + width >= scrollWidth - 1};
        },
        write: function(measurement){
        if(prev && next){
          if(measurement.overflow){ prev.classList.add('is-visible'); next.classList.add('is-visible'); }
          else{ prev.classList.remove('is-visible'); next.classList.remove('is-visible'); }
        }
        if(prev) prev.disabled = measurement.atStart;
        if(next) next.disabled = measurement.atEnd;
        }
      };
      function update(){
        scheduleCarouselJob(carouselJob);
      }
      
      // Guarda referência para poder chamar depois
      carousel._viUpdate = update;
      
      // Se já foi inicializado, apenas atualiza
      if (carousel.dataset.viBound === '1') {
        requestAnimationFrame(update);
        return;
      }

      function step(dir){
        var item = rail.firstElementChild;
        var gap = 6;
        try{
          var cs = getComputedStyle(rail);
          gap = parseInt(cs.columnGap || cs.gap, 10) || 6;
        }catch(_){ }
        var delta = (item ? item.offsetWidth : 24) + gap;
        var visible = Math.max(1, Math.floor(viewport.clientWidth / delta));
        viewport.scrollBy({ left: dir * delta * visible, behavior: 'smooth' });
      }
      prev && prev.addEventListener('click', function(){ step(-1); });
      next && next.addEventListener('click', function(){ step(1); });
      viewport.addEventListener('scroll', update);
      window.addEventListener('resize', update);
      requestAnimationFrame(update);
      carousel.dataset.viBound = '1';
      
      // Observer para atualizar quando o carrossel se torna visível
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if (entry.isIntersecting) {
              requestAnimationFrame(update);
            }
          });
        }, { threshold: 0.1 });
        obs.observe(carousel);
      }
    }

    root.querySelectorAll('.vi-carousel').forEach(setupCarousel);

    (function initLayers(){
      var box = root.querySelector('.vi-imgbox');
      if(!box) return;
      if(box.querySelector('.vi-layer')) return;
      var l1 = document.createElement('div'); l1.className = 'vi-layer is-active';
      var l2 = document.createElement('div'); l2.className = 'vi-layer';
      while(box.firstChild){ l1.appendChild(box.firstChild); }
      box.appendChild(l1); box.appendChild(l2);
    })();

    (function initOverlay(){
      var box = root.querySelector('.vi-imgbox');
      var labels = root.querySelector('.vi-labels');
      if(!box || !labels) return;
      var ov = box.querySelector('.vi-overlay');
      if(!ov){
        ov = document.createElement('div');
        ov.className = 'vi-overlay';
        ov.style.position = 'absolute';
        ov.style.inset = '0';
        ov.style.pointerEvents = 'none';
        ov.style.zIndex = '3';
        box.appendChild(ov);
      }
      labels.style.position = 'absolute';
      labels.style.left = '8px';
      labels.style.top  = '8px';
      labels.style.zIndex = '10';
      labels.style.pointerEvents = 'none';
      ov.appendChild(labels);
    })();

    function createImg(src, cls, altText){
      if(!src) return null;
      var img = new Image();
      img.decoding = 'async';
      img.loading = 'eager';
      img.fetchPriority = 'high';
      img.className = cls;
      img.alt = altText || productTitle || '';
      img.src = src;
      return img;
    }

    function preloadVideoElement(src){
      if(!src) return null;
      var v = document.createElement('video');
      v.className = 'vi-video';
      v.preload = 'metadata';
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.autoplay = true;
      v.setAttribute('muted','');
      v.setAttribute('loop','');
      v.setAttribute('playsinline','');
      v.setAttribute('autoplay','');
      var s = document.createElement('source');
      s.src = src;
      s.type = 'video/mp4';
      v.appendChild(s);
      return v;
    }

    function waitForMedia(el, readyEvent){
      if(!el) return Promise.resolve();
      return new Promise(function(resolve){
        var settled = false;
        var timer = null;
        function finish(){
          if(settled) return;
          settled = true;
          el.removeEventListener(readyEvent, finish);
          el.removeEventListener('error', finish);
          if(timer) clearTimeout(timer);
          resolve();
        }
        el.addEventListener(readyEvent, finish, {once:true});
        el.addEventListener('error', finish, {once:true});
        timer = setTimeout(finish, 6000);
      });
    }

    function appendSecondaryMedia(container, src, waits){
      if(!container || !src) return null;
      if(isVideoSrc(src)){
        var secondaryVideo = preloadVideoElement(src);
        if(!secondaryVideo) return null;
        secondaryVideo.className = 'vi-video vi-video--secondary';
        container.appendChild(secondaryVideo);
        if(secondaryVideo.readyState < 2){
          waits.push(waitForMedia(secondaryVideo, 'loadeddata'));
        }
        return secondaryVideo;
      }
      var secondaryImage = createImg(src, 'vi-img vi-img--secondary');
      if(!secondaryImage) return null;
      container.appendChild(secondaryImage);
      if(secondaryImage.decode){
        waits.push(secondaryImage.decode().catch(function(){}));
      }else if(!secondaryImage.complete){
        waits.push(waitForMedia(secondaryImage, 'load'));
      }
      return secondaryImage;
    }

    function mediaElementSource(el){
      if(!el) return '';
      if(el.tagName === 'VIDEO'){
        var source = el.querySelector('source');
        return el.currentSrc || (source && source.src) || '';
      }
      return el.currentSrc || el.src || el.getAttribute('data-remote-src') || '';
    }

    function showBusy(on){
      var box = root.querySelector('.vi-imgbox');
      if(!box) return;
      var busy = box.querySelector('.vi-busy');
      if(on){
        if(!busy){
          busy = document.createElement('div');
          busy.className = 'vi-busy';
          box.appendChild(busy);
        }
      }else if(busy){
        busy.remove();
      }
    }

    function swapMedia(data){
      var box = root.querySelector('.vi-imgbox');
      if(!box) return;
      var active = box.querySelector('.vi-layer.is-active');
      var layers = box.querySelectorAll('.vi-layer');
      var idle = (layers[0] === active) ? layers[1] : layers[0];

      var effectiveVideo = data.video;
      if(!effectiveVideo && data.primary && /\.(mp4|webm|mov)(\?|$)/i.test(String(data.primary))){
        effectiveVideo = data.primary;
      }
      if(!effectiveVideo && !data.primary && isVideoSrc(data.secondary)){
        effectiveVideo = data.secondary;
      }
      var hasIncomingMedia = !!(effectiveVideo || data.primary || data.secondary);
      if(!hasIncomingMedia){
        showBusy(false);
        return;
      }

      idle.textContent = '';
      showBusy(true);
      var waits = [];
      var videoEl = null;
      if(effectiveVideo){
        var v = preloadVideoElement(effectiveVideo);
        if(v){
          idle.appendChild(v);
          videoEl = v;
          if(v.readyState < 2){
            waits.push(new Promise(function(res){ v.addEventListener('loadeddata', res, {once:true}); }));
          }
          v.addEventListener('loadeddata', function handleLoaded(){
            v.removeEventListener('loadeddata', handleLoaded);
            var playPromise = v.play && v.play();
            if(playPromise && typeof playPromise.catch === 'function'){ playPromise.catch(function(){}); }
          }, {once:true});
        }
        if(data.secondary && data.secondary !== effectiveVideo){
          appendSecondaryMedia(idle, data.secondary, waits);
        }
      } else if(data.primary || data.secondary){
        var img1 = createImg(data.primary || data.secondary, 'vi-img vi-img--primary');
        if(img1){
          idle.appendChild(img1);
          if(img1.decode){
            waits.push(img1.decode().catch(function(){}));
          }else{
            waits.push(new Promise(function(resolve){ img1.addEventListener('load', resolve, {once:true}); }));
          }
        }
        // Fallback: se data.secondary vazio, preserva o secondary que o SSR colocou na layer ativa
        var effectiveSecondary2 = (data.secondary && data.primary) ? data.secondary : '';
        if(!effectiveSecondary2 && active && String(data.vid || '') === String(root.getAttribute('data-variant-id') || '')){
          var ssrSec2 = active.querySelector('.vi-img--secondary, .vi-video--secondary');
          effectiveSecondary2 = mediaElementSource(ssrSec2);
        }
        if(effectiveSecondary2){
          appendSecondaryMedia(idle, effectiveSecondary2, waits);
        }
      }
      Promise.allSettled(waits).then(function(){
        showBusy(false);
        if(active){ active.classList.remove('is-active'); }
        if(idle){ idle.classList.add('is-active'); }
        if(videoEl){
          var playPromise = videoEl.play && videoEl.play();
          if(playPromise && typeof playPromise.catch === 'function'){ playPromise.catch(function(){}); }
        }
      }).catch(function(){ showBusy(false); });
    }

    function updateLabels(mode){
      var labels = root.querySelector('.vi-labels');
      if(!labels) return;
      var state = mode || 'available';
      // O id dos <template> usa sufixos curtos (-avail/-avm/-soldout), diferentes do nome do estado.
      var tplSuffix = { 'available': 'avail', 'avm': 'avm', 'sold-out': 'soldout' }[state] || state;
      var tplId = cardUid ? (cardUid + '-labels-' + tplSuffix) : '';
      var tpl = tplId ? document.getElementById(tplId) : null;
      if (tpl && tpl.innerHTML != null){
        labels.innerHTML = tpl.innerHTML.trim();
      } else {
        // Fallback: remove qualquer tarja de status gerenciada e recria a do estado atual.
        var managed = labels.querySelectorAll('[data-label="avm"],[data-label="sold-out"]');
        managed.forEach(function(el){ el.remove(); });
        if (state === 'avm') {
          var span = document.createElement('span');
          span.className = 'label label--highlight';
          span.setAttribute('data-label','avm');
          span.textContent = 'Avise-me';
          labels.prepend(span);
        } else if (state === 'sold-out') {
          var soldSpan = document.createElement('span');
          soldSpan.className = 'label label--subdued';
          soldSpan.setAttribute('data-label','sold-out');
          soldSpan.textContent = 'Esgotado';
          labels.prepend(soldSpan);
        }
      }
      var hasText = (labels.textContent || '').trim().length > 0;
      labels.classList.toggle('is-empty', !hasText);
    }

    function updateSeals(data){
      var wrap = root.querySelector('.product-item__image-wrapper');
      if(!wrap) return;
      var selectors = [
        '.product-item__selo-direita-superior',
        '.product-item__selo-direita-inferior',
        '.product-item__selo-esquerda-superior',
        '.product-item__selo-esquerda-inferior'
      ];
      if(!data || !data.avail){
        selectors.forEach(function(selector){
          var el = wrap.querySelector(selector);
          if(el) el.style.display = 'none';
        });
        return;
      }
      function setSelo(selector, url){
        var el = wrap.querySelector(selector);
        if(url){
          try{
            var sealUrl = new URL(url, window.location.origin);
            if(sealUrl.hostname === 'cdn.shopify.com' || sealUrl.pathname.indexOf('/cdn/shop/') !== -1){
              sealUrl.searchParams.set('width', '160');
              url = sealUrl.toString();
            }
          }catch(_){ }
          if(!el){
            el = document.createElement('div');
            el.className = selector.slice(1);
            var img = document.createElement('img');
            img.loading = 'lazy';
            img.alt = productTitle || 'Selo';
            el.appendChild(img);
            wrap.appendChild(el);
          }
          var imgTag = el.querySelector('img') || document.createElement('img');
          imgTag.src = url;
          if(!imgTag.parentNode) el.appendChild(imgTag);
          imgTag.alt = productTitle || 'Selo';
          el.style.display = '';
        }else if(el){
          el.style.display = 'none';
        }
      }
      setSelo(selectors[0], data.selo_ds);
      setSelo(selectors[1], data.selo_di);
      setSelo(selectors[2], data.selo_es);
      setSelo(selectors[3], data.selo_ei);
    }

    function fmt(cents){
      try{
        if(window.Shopify && typeof Shopify.formatMoney === 'function'){
          return Shopify.formatMoney(cents, moneyFormat);
        }
      }catch(_){ }
      var value = Number(cents || 0) / 100;
      return 'R$ ' + value.toFixed(2).replace('.', ',');
    }

    function updateCTA(mode){
      var state = mode || 'available';
      root.classList.toggle('is-oos', state === 'avm');
      root.classList.toggle('is-soldout', state === 'sold-out');
      root.setAttribute('data-oos-mode', state);
    }

    function readButtonMedia(btn){
      return normalizeMediaData({
        primary: btn && btn.getAttribute ? (btn.getAttribute('data-primary') || '') : '',
        secondary: btn && btn.getAttribute ? (btn.getAttribute('data-secondary') || '') : '',
        video: btn && btn.getAttribute ? (btn.getAttribute('data-video') || '') : ''
      });
    }

    function resolveSelectionMedia(btn){
      var inlineMedia = readButtonMedia(btn);
      if(inlineMedia.primary || inlineMedia.secondary || inlineMedia.video){
        return Promise.resolve(inlineMedia);
      }
      var btnVariantId = btn && btn.getAttribute ? (btn.getAttribute('data-vid') || '') : '';
      var rootVariantId = String(root.getAttribute('data-variant-id') || '');
      if(btnVariantId && rootVariantId && btnVariantId === rootVariantId){
        var currentMedia = readRootMedia(root);
        if(currentMedia.primary || currentMedia.secondary || currentMedia.video){
          return Promise.resolve(currentMedia);
        }
      }
      var handle = root.getAttribute('data-product-handle') || '';
      return fetchVariantMedia(handle, btnVariantId).then(function(remoteMedia){
        if(remoteMedia.primary || remoteMedia.secondary || remoteMedia.video){
          return remoteMedia;
        }
        return readRootMedia(root);
      });
    }

    function prefetchSelectionMedia(btn){
      resolveSelectionMedia(btn).catch(function(){});
    }

    (function bindCtaPersonalizeFlag(){
      var ctas = root.querySelectorAll('[data-vi-cta]');
      ctas.forEach(function(btn){
        btn.addEventListener('click', function(){
          var cta = (btn.getAttribute('data-vi-cta')||'');
          var isAvm = cta.indexOf('avm-') === 0;
          var availableNow = !root.classList.contains('is-oos') && !root.classList.contains('is-soldout');
          var flag = isAvm ? true : !availableNow;
          window.__personalizeDisabled = !!flag;
          if(flag){
            document.documentElement.setAttribute('data-disable-personalize','true');
          }else{
            document.documentElement.removeAttribute('data-disable-personalize');
          }
        }, {capture:true});
      });
    })();

    function applySelection(data, btn){
      if(btn){
        var rail = btn.closest('.vi-rail');
        if(rail){
          rail.querySelectorAll('.is-active').forEach(function(el){ el.classList.remove('is-active'); });
          btn.classList.add('is-active');
        }
      }
      if(!data.preserveMedia) swapMedia(data);
      var priceCents = Number(data.price);
      if (!Number.isFinite(priceCents)) priceCents = 0;
      var compareCents = Number(data.compare);
      if (!Number.isFinite(compareCents)) compareCents = 0;
      var discountPrice = parseInt(data.discountPrice || data.discount_price || '0', 10) || 0;
      var discountScope = data.discountSource || data.discount_scope || '';
      var variantId = data.vid;
      var targetVariantRaw = 'targetVariant' in data ? (data.targetVariant || '') : '';
      var targetProductRaw = 'targetProduct' in data ? (data.targetProduct || '') : '';
      var metaVariant = parseMeta(targetVariantRaw);
      var metaProduct = parseMeta(targetProductRaw);
      var autoVariant = getAutomaticPct(metaVariant, variantId);
      var autoProduct = getAutomaticPct(metaProduct, variantId);
      var activeCode = detectCode();
      var codeActive = !!activeCode;
      var codeProduct = codeActive ? getCodesPct(metaProduct, activeCode, variantId) : 0;
      var codeVariant = codeActive ? getCodesPct(metaVariant, activeCode, variantId) : 0;

      var fallbackRootPrice = parseInt(root.dataset.priceCents || root.getAttribute('data-price-cents') || '0', 10) || 0;
      var baseCents = priceCents || fallbackRootPrice || compareCents;
      var compareBase = compareCents > baseCents ? compareCents : 0;
      if (!compareBase && fallbackRootPrice > baseCents) {
        compareBase = fallbackRootPrice;
      }

      var pct = 0;
      var source = '';
      var currentCents = baseCents;

      if (discountPrice > 0) {
        if (baseCents > 0 && discountPrice > baseCents) {
          var dpScale = discountPrice;
          for (var i = 0; i < 6 && dpScale > baseCents && dpScale % 10 === 0; i += 1) {
            dpScale = Math.floor(dpScale / 10);
          }
          discountPrice = dpScale;
        }
        currentCents = discountPrice;
        if (!compareBase || compareBase <= currentCents) {
          compareBase = baseCents || compareCents || fallbackRootPrice || currentCents;
        }
        source = (discountScope ? discountScope + '-' : '') + 'discount-pricing';
      } else {
        if (autoVariant > 0) {
          pct = autoVariant;
          source = 'variant-auto';
        } else if (codeActive && codeVariant > 0) {
          pct = codeVariant;
          source = 'variant-code';
        } else if (autoProduct > 0) {
          pct = autoProduct;
          source = 'product-auto';
        } else if (codeActive && codeProduct > 0) {
          pct = codeProduct;
          source = 'product-code';
        }

        if (pct > 0 && baseCents > 0) {
          var off = Math.round(baseCents * (pct / 100));
          currentCents = Math.max(0, baseCents - off);
          compareBase = Math.max(compareBase, baseCents);
        }
      }


      if (source) {
        root.dataset.discountSource = source;
      } else {
        delete root.dataset.discountSource;
      }
      var mode = data.oosMode || (data.avail ? 'available' : 'avm');
      root.setAttribute('data-available', data.avail ? 'true' : 'false');
      if (data.vid) {
        root.setAttribute('data-variant-id', data.vid);
        root.dataset.variantId = String(data.vid);
      }
      if ('primary' in data) {
        if (data.primary) {
          root.setAttribute('data-variant-main', data.primary);
        } else {
          root.removeAttribute('data-variant-main');
        }
      }
      if ('secondary' in data) {
        if (data.secondary) {
          root.setAttribute('data-variant-hover', data.secondary);
        } else {
          root.removeAttribute('data-variant-hover');
        }
      }
      if ('video' in data) {
        if (data.video) {
          root.setAttribute('data-variant-video', data.video);
        } else {
          root.removeAttribute('data-variant-video');
        }
      }
      if ('targetVariant' in data) {
        var variantMeta = data.targetVariant || '';
        root.setAttribute('data-target-descontos', variantMeta);
        root.setAttribute('data-target-descontos-variant', variantMeta);
      }
      if ('targetProduct' in data) {
        var productMeta = data.targetProduct || '';
        root.setAttribute('data-target-descontos-product', productMeta);
      }

      if (baseCents > 0) {
        root.dataset.priceCents = String(baseCents);
        root.setAttribute('data-price-cents', String(baseCents));
      }
      if (discountPrice > 0) {
        root.dataset.discountPrice = String(discountPrice);
        root.setAttribute('data-discount-price', String(discountPrice));
        if (discountScope) {
          root.setAttribute('data-discount-price-scope', discountScope);
        } else {
          root.removeAttribute('data-discount-price-scope');
        }
      } else {
        delete root.dataset.discountPrice;
        root.removeAttribute('data-discount-price');
        root.removeAttribute('data-discount-price-scope');
      }
      root.dataset.origPrice = String(baseCents);
      root.setAttribute('data-orig-price', String(baseCents));
      if (compareBase > 0) {
        root.dataset.origCompare = String(compareBase);
      } else {
        delete root.dataset.origCompare;
      }
      var nowEl = root.querySelector('.vi-now');
      if(nowEl){
        var baseStr = String(baseCents);
        nowEl.dataset.amount = String(currentCents);
        nowEl.dataset.origAmount = baseStr;
        nowEl.dataset.originalAmount = baseStr;
        nowEl.dataset.origText = fmt(baseCents);
        nowEl.textContent = fmt(currentCents);
      }
      var wasEl = root.querySelector('.vi-was');
      if(wasEl){
        if(compareBase > currentCents){
          var compareStr = String(compareBase);
          wasEl.dataset.amount = compareStr;
          wasEl.dataset.origAmount = compareStr;
          wasEl.dataset.originalAmount = compareStr;
          wasEl.dataset.origText = fmt(compareBase);
          wasEl.textContent = fmt(compareBase);
          wasEl.style.display = '';
        } else {
          delete wasEl.dataset.amount;
          delete wasEl.dataset.origAmount;
          delete wasEl.dataset.originalAmount;
          delete wasEl.dataset.origText;
          wasEl.textContent = '';
          wasEl.style.display = 'none';
        }
      }
      var instEl = root.querySelector('.vi-install');
      if(instEl){
        var n = minInstall > 0 ? Math.floor(currentCents / minInstall) : 0;
        if(n > maxInstall) n = maxInstall;
        if(n < 1) n = 1;
        if(n > 1){
          var per = Math.ceil(currentCents/n);
          instEl.textContent = 'ou em até ' + n + 'x ' + fmt(per) + ' sem juros';
        } else {
          instEl.textContent = '';
        }
        instEl.dataset.origText = instEl.textContent || '';
      }
      var input = root.querySelector('[data-vi-variant-input]'); 
      if(input) input.value = data.vid;
      var imgLink = root.querySelector('.vi-card__img'); 
      if(imgLink) imgLink.setAttribute('href', data.vurl);
      var titleLink = root.querySelector('.vi-card__title'); 
      if(titleLink) titleLink.setAttribute('href', data.vurl);
      var pop = root.querySelector('quick-buy-popover'); 
      if(pop) pop.setAttribute('href', data.vurl);
      var drw = root.querySelector('quick-buy-drawer'); 
      if(drw) drw.setAttribute('href', data.vurl);
      updateLabels(mode);
      if(!data.preserveMedia) updateSeals(data);
      updateCTA(mode);
    }

    function handleVariantTrigger(target, initial){
      var btn = target.closest ? target.closest('[data-vi-select]') : null;
      if(!btn) return;
      var requestId = ++activeVariantRequest;
      var baseData = {
        vid: btn.getAttribute('data-vid'),
        vurl: btn.getAttribute('data-vurl'),
        price: parseInt(btn.getAttribute('data-price'), 10) || 0,
        compare: parseInt(btn.getAttribute('data-compare'), 10) || 0,
        discountPrice: parseInt(btn.getAttribute('data-discount-price'), 10) || 0,
        discountSource: btn.getAttribute('data-discount-source') || '',
        avail: btn.getAttribute('data-avail') === '1',
        oosMode: btn.getAttribute('data-oos-mode') || (btn.getAttribute('data-avail') === '1' ? 'available' : 'avm'),
        selo_ds: btn.getAttribute('data-selo-ds') || '',
        selo_di: btn.getAttribute('data-selo-di') || '',
        selo_es: btn.getAttribute('data-selo-es') || '',
        selo_ei: btn.getAttribute('data-selo-ei') || '',
        targetVariant: btn.getAttribute('data-target-descontos-variant') || '',
        targetProduct: btn.getAttribute('data-target-descontos-product') || ''
      };
      if(initial && String(root.getAttribute('data-variant-id')) === String(baseData.vid) && root.querySelector('.vi-img--primary, .vi-video:not(.vi-video--secondary)')){
        baseData.preserveMedia = true;
        applySelection(baseData, btn);
        return;
      }
      resolveSelectionMedia(btn).then(function(media){
        if(requestId !== activeVariantRequest) return;
        applySelection({
          vid: baseData.vid,
          vurl: baseData.vurl,
          price: baseData.price,
          compare: baseData.compare,
          discountPrice: baseData.discountPrice,
          discountSource: baseData.discountSource,
          primary: media.primary,
          secondary: media.secondary,
          video: media.video,
          avail: baseData.avail,
          oosMode: baseData.oosMode,
          selo_ds: baseData.selo_ds,
          selo_di: baseData.selo_di,
          selo_es: baseData.selo_es,
          selo_ei: baseData.selo_ei,
          targetVariant: baseData.targetVariant,
          targetProduct: baseData.targetProduct
        }, btn);
      }).catch(function(){
        if(requestId !== activeVariantRequest) return;
        applySelection({
          vid: baseData.vid,
          vurl: baseData.vurl,
          price: baseData.price,
          compare: baseData.compare,
          discountPrice: baseData.discountPrice,
          discountSource: baseData.discountSource,
          primary: '',
          secondary: '',
          video: '',
          avail: baseData.avail,
          oosMode: baseData.oosMode,
          selo_ds: baseData.selo_ds,
          selo_di: baseData.selo_di,
          selo_es: baseData.selo_es,
          selo_ei: baseData.selo_ei,
          targetVariant: baseData.targetVariant,
          targetProduct: baseData.targetProduct
        }, btn);
      });
    }

    root.addEventListener('pointerdown', function(e){ handleVariantTrigger(e.target); }, {passive:true});
    root.addEventListener('pointerover', function(e){
      var btn = e.target && e.target.closest ? e.target.closest('[data-vi-select]') : null;
      if(!btn || !root.contains(btn)) return;
      prefetchSelectionMedia(btn);
    }, {passive:true});
    root.addEventListener('focusin', function(e){
      var btn = e.target && e.target.closest ? e.target.closest('[data-vi-select]') : null;
      if(!btn || !root.contains(btn)) return;
      prefetchSelectionMedia(btn);
    });
    root.addEventListener('click', function(e){
      if(e.target && e.target.closest && e.target.closest('[data-vi-select]')) e.preventDefault();
    });

      var initialVariantId = root.getAttribute('data-variant-id') || '';
      var initialBtn = root.querySelector('[data-vi-select][data-vid="' + initialVariantId + '"]') || root.querySelector('[data-vi-select].is-active') || root.querySelector('[data-vi-select]');
      if (initialBtn) {
        handleVariantTrigger(initialBtn, true);
      } else if (!root.querySelector('[data-vi-select]')) {
        var variantId = parseInt(root.getAttribute('data-variant-id'), 10) || 0;
        var basePrice = parseInt(root.getAttribute('data-orig-price'), 10) || parseInt(root.dataset.origPrice || root.dataset.priceCents || '0', 10) || 0;
        var discountPrice = parseInt(root.getAttribute('data-discount-price') || root.dataset.discountPrice || '0', 10) || 0;
        var discountScope = root.getAttribute('data-discount-price-scope') || root.dataset.discountPriceScope || '';
        var metaVariantRaw = root.getAttribute('data-target-descontos-variant') || '';
        var metaProductRaw = root.getAttribute('data-target-descontos-product') || '';
        var metaVariant = parseMeta(metaVariantRaw);
        var metaProduct = parseMeta(metaProductRaw);
        var activeCode = detectCode();
        var automaticVariant = getAutomaticPct(metaVariant, variantId);
        var automaticProduct = getAutomaticPct(metaProduct, variantId);
        var codeVariant = activeCode ? getCodesPct(metaVariant, activeCode, variantId) : 0;
        var codeProduct = activeCode ? getCodesPct(metaProduct, activeCode, variantId) : 0;
        var pct = 0;
        if (automaticVariant > 0) {
          pct = automaticVariant;
        } else if (codeVariant > 0) {
          pct = codeVariant;
        } else if (automaticProduct > 0) {
          pct = automaticProduct;
        } else if (codeProduct > 0) {
          pct = codeProduct;
        }
        if (basePrice > 0 && (discountPrice > 0 || pct > 0)) {
          if (discountPrice > basePrice) {
            var dpScale = discountPrice;
            for (var i2 = 0; i2 < 6 && dpScale > basePrice && dpScale % 10 === 0; i2 += 1) {
              dpScale = Math.floor(dpScale / 10);
            }
            discountPrice = dpScale;
          }
          var discounted = discountPrice > 0 ? discountPrice : Math.max(0, basePrice - Math.round(basePrice * (pct / 100)));
          var imgLinkEl = root.querySelector('.vi-card__img');
          var href = imgLinkEl ? imgLinkEl.getAttribute('href') : '';
          var wrapEl = root.querySelector('.product-item__image-wrapper');
          function readSelo(selector){
            if(!wrapEl) return '';
            var img = wrapEl.querySelector(selector + ' img');
            return img ? img.getAttribute('src') : '';
          }
          var compareVal = basePrice;
          if (compareVal <= discounted) {
            compareVal = parseInt(root.getAttribute('data-orig-compare'), 10) || basePrice;
          }
          var payload = {
            vid: variantId,
            vurl: href || '',
            price: discounted,
            compare: compareVal,
            primary: '',
            secondary: '',
            video: '',
            avail: root.getAttribute('data-available') === 'true',
            oosMode: root.getAttribute('data-oos-mode') || (root.getAttribute('data-available') === 'true' ? 'available' : 'avm'),
            selo_ds: readSelo('.product-item__selo-direita-superior'),
            selo_di: readSelo('.product-item__selo-direita-inferior'),
            selo_es: readSelo('.product-item__selo-esquerda-superior'),
            selo_ei: readSelo('.product-item__selo-esquerda-inferior'),
            targetVariant: metaVariantRaw,
            targetProduct: metaProductRaw,
            discountPrice: discountPrice,
            discountSource: discountPrice > 0 ? discountScope : ''
          };
          applySelection(payload, null);
        }
      }
  }

  function runInlineVariantScripts(scope){
    var ctx = scope && scope.querySelectorAll ? scope : document;
    if(!ctx || !ctx.querySelectorAll) return;
    ctx.querySelectorAll('script[data-vi-inline]').forEach(function(script){
      if(!script || script.dataset.viExecuted === '1') return;
      var typeAttr = (script.getAttribute('type') || '').trim();
      if(typeAttr && typeAttr !== 'text/javascript' && typeAttr !== 'application/javascript' && typeAttr !== 'module'){
        return;
      }
      var parent = script.parentNode;
      if(!parent) return;
      var cardRoot = script.closest ? script.closest('variant-item') : null;
      if(cardRoot){
        delete cardRoot.dataset.viReady;
        cardRoot.removeAttribute('data-vi-ready');
      }
      var clone = document.createElement('script');
      if(typeAttr) clone.type = typeAttr;
      if(script.hasAttribute('nonce')){
        clone.setAttribute('nonce', script.getAttribute('nonce'));
      }
      clone.textContent = script.textContent;
      clone.dataset.viInline = script.getAttribute('data-vi-inline') || '';
      clone.dataset.viExecuted = '1';
      parent.replaceChild(clone, script);
    });
  }

  function initWithin(scope){
    var ctx = scope && scope.querySelectorAll ? scope : document;
    var nodes = ctx.querySelectorAll ? ctx.querySelectorAll('variant-item[id]') : [];
    nodes.forEach(function(node){ initCard(node); });
  }

  function drainQueue(){
    var queue = window.__viCardQueue;
    if(!Array.isArray(queue) || !queue.length) return;
    while(queue.length){
      var id = queue.shift();
      initCard(id);
    }
  }

  function overridePush(){
    var queue = window.__viCardQueue;
    if(!Array.isArray(queue)){
      queue = [];
      window.__viCardQueue = queue;
    }
    var nativePush = queue.push;
    if(queue.__viWrapped) return;
    queue.__viWrapped = true;
    queue.push = function(){
      var res = Array.prototype.push.apply(queue, arguments);
      drainQueue();
      return res;
    };
  }

  window.__viInitCard = initCard;
  window.__viInitAll = function(scope){
    initWithin(scope || document);
    drainQueue();
  };

  window.__viRunVariantScripts = function(scope){
    var target = scope && scope.querySelectorAll ? scope : document;
    runInlineVariantScripts(target);
    if(window.__viInitAll){
      window.__viInitAll(target);
    }else{
      initWithin(target);
      drainQueue();
    }
  };

  function handleScopeEvent(event){
    if(event && event.detail && event.detail.skipVariantInit){
      return;
    }
    var scope = null;
    if(event){
      if(event.detail && event.detail.scope){ scope = event.detail.scope; }
      else if(event.detail && event.detail.container){ scope = event.detail.container; }
      else if(event.target instanceof Element){ scope = event.target; }
    }
    initWithin(scope || document);
    drainQueue();
  }

  document.addEventListener('collection:items:added', handleScopeEvent);
  document.addEventListener('search:items:added', handleScopeEvent);
  document.addEventListener('facets:updated', handleScopeEvent);
  document.addEventListener('shopify:section:load', handleScopeEvent);

  if(window.MutationObserver){
    var observer = new MutationObserver(function(records){
      records.forEach(function(record){
        record.addedNodes && record.addedNodes.forEach(function(node){
          if(!node || node.nodeType !== 1) return;
          if(node.matches && node.matches('variant-item')){
            initCard(node);
          }else if(node.querySelectorAll){
            node.querySelectorAll('variant-item').forEach(function(child){ initCard(child); });
          }
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function(){
    initWithin(document);
    drainQueue();
  });

  overridePush();
  drainQueue();
  initWithin(document);

  function viCardProductIdFromForm(form){
    if(!form) return '';
    var inp = form.querySelector('input[name="product-id"], input[name="product_id"], input[name="product[id]"]');
    return inp && inp.value ? String(inp.value).trim() : '';
  }

  function viCardBuildColorRowMap(rows, sizeIdx, colorIdx, sizeVal){
    var map = Object.create(null);
    if(!rows || !rows.length || colorIdx < 0) return map;
    for(var i = 0; i < rows.length; i++){
      var r = rows[i];
      var o = r.o || [];
      if(sizeIdx >= 0 && sizeVal != null && String(sizeVal) !== ''){
        if(String(o[sizeIdx] || '').trim() !== String(sizeVal).trim()) continue;
      }
      var ck = String(o[colorIdx] || '').toLowerCase().trim();
      if(!ck) continue;
      map[ck] = r;
    }
    return map;
  }

  function viCardSyncVariantItemWithPdp(root, detail, eventTarget){
    if(!root || !detail || !detail.variant) return;
    var form = eventTarget && eventTarget.closest && eventTarget.closest('form[is="product-form"]');
    if(!form) return;
    // Quick Buy / product-rerender no overlay: não espelhar na grade da coleção
    // (evita trocar imagem/preço de todos os cards do mesmo product-id ao mudar cor no drawer).
    if(form.closest('quick-buy-drawer, quick-buy-popover, .drawer--quick-buy, .popover--quick-buy')){
      return;
    }
    var pid = viCardProductIdFromForm(form);
    var cardPid = String(root.getAttribute('data-product-id') || '').trim();
    if(!pid || !cardPid || pid !== cardPid) return;

    var szIdx = parseInt(root.getAttribute('data-vi-opt-size') || '-1', 10);
    var coIdx = parseInt(root.getAttribute('data-vi-opt-color') || '-1', 10);
    if(coIdx < 0) return;

    var jsonEl = document.getElementById(root.id + '-vi-variant-rows');
    if(!jsonEl) return;
    var rows;
    try{ rows = JSON.parse(jsonEl.textContent || '[]'); }catch(_){ return; }

    var opts = detail.variant.options || [];
    var sizeVal = szIdx >= 0 ? opts[szIdx] : '';
    var map = viCardBuildColorRowMap(rows, szIdx, coIdx, sizeVal);
    var handle = root.getAttribute('data-product-handle') || '';
    var addon = parseInt(root.getAttribute('data-addon-price') || '0', 10) || 0;

    root.querySelectorAll('[data-vi-select]').forEach(function(btn){
      var ck = (btn.getAttribute('data-color-key') || '').toLowerCase().trim();
      if(!ck) return;
      var cell = map[ck];
      if(!cell) return;
      var baseP = Number(cell.p) || 0;
      var cmpRaw = Number(cell.c) || 0;
      var compareAt = cmpRaw > baseP ? cmpRaw : 0;
      var cellMode = cell.m || (cell.a ? 'available' : 'avm');
      btn.setAttribute('data-vid', String(cell.i));
      btn.setAttribute('data-avail', cell.a ? '1' : '0');
      btn.setAttribute('data-oos-mode', cellMode);
      btn.setAttribute('data-price', String(baseP + addon));
      btn.setAttribute('data-price-base', String(baseP));
      btn.setAttribute('data-compare', String(compareAt > 0 ? compareAt + addon : 0));
      btn.setAttribute('data-compare-base', String(compareAt > baseP ? compareAt : 0));
      if(handle){
        btn.setAttribute('data-vurl', '/products/' + handle + '?variant=' + cell.i);
      }
      btn.classList.toggle('is-oos', cellMode !== 'available');
    });

    var colorVal = String(opts[coIdx] || '').toLowerCase().trim();
    var matchBtn = null;
    root.querySelectorAll('[data-vi-select]').forEach(function(b){
      if((b.getAttribute('data-color-key') || '').toLowerCase().trim() === colorVal){
        matchBtn = b;
      }
    });
    var activeBtn = matchBtn || root.querySelector('[data-vi-select].is-active') || root.querySelector('[data-vi-select]');
    if(!activeBtn) return;
    root.querySelectorAll('[data-vi-select].is-active').forEach(function(b){ b.classList.remove('is-active'); });
    activeBtn.classList.add('is-active');
    try{
      if(typeof PointerEvent === 'function'){
        activeBtn.dispatchEvent(new PointerEvent('pointerdown', { bubbles: true, cancelable: true }));
      }else{
        activeBtn.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
      }
    }catch(_){
      activeBtn.click();
    }
  }

  if(!window.__viPdpSyncBound){
    window.__viPdpSyncBound = true;
    document.addEventListener('variant:changed', function(e){
      var detail = e && e.detail;
      if(!detail || !detail.variant) return;
      var target = e.target;
      document.querySelectorAll('variant-item[id][data-product-id][data-vi-opt-color]').forEach(function(root){
        viCardSyncVariantItemWithPdp(root, detail, target);
      });
    }, true);
  }
})();
